type LayoutProps = {
  user: React.ReactNode;
  menu: React.ReactNode;
  title: React.ReactNode;
  children: React.ReactNode;
};

const Layout: React.FC<LayoutProps> = ({ menu, title, user, children }) => {
  return (
    <div className="flex flex-row justify-between grow h-full overflow-hidden bg-bg">
      <div className="w-[32rem] shrink-0 grow-0 overflow-y-auto overflow-x-hidden">
        {menu}
      </div>
      <section className="flex flex-col flex-1 m-sm bg-content p-lg pl-4xl rounded-md text-small overflow-hidden">
        <div className="h-[4rem] flex flex-row justify-between grow-0 gap-xl">
          {title}
          {user}
        </div>
        <div className="flex-1 overflow-y-auto overflow-x-auto flex mt-sm">
          {children}
        </div>
      </section>
    </div>
  );
};

export default Layout;
export { Menu } from './Menu';
export { default as UserBar } from './UserBar';
